import React, { useEffect, useState } from "react";
import { Col, Container, Spinner } from "react-bootstrap";
import TitleBar from "../components/TitleBar/TitleBar";
import { useDispatch, useSelector } from "react-redux";
import { contactEnquiry } from "../redux/actionCreator";
import { toast } from "react-toastify";
import i18n from "../i18n";
import { contact_details, contact_submit_loading } from "../redux/commonReducer";
import { t } from "i18next";
import { useRef } from "react";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import Select from "react-select";

function Contact() {

  const dispatch = useDispatch()

  // SELECTORS
  const contactData = useSelector(contact_details)
  const loading = useSelector(contact_submit_loading)

  const [disabled, setDisabled] = useState(false)
  const ref = useRef()
  const fileInputRef = useRef(null)
  // LANGUAGE
  const [lang, setLang] = useState("");
  const langSwitch = i18n?.language === "en";
  useEffect(() => {
    i18n.on("languageChanged", (language) => {
      setLang(language);
    });
  }, [lang, i18n]);

  const [errors, setErrors] = useState({});
  const [captchaValue, setCaptchaValue] = useState("");
  const [value, setValue] = useState("")
  const [data, setData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    image: '',
    country_code: "+971"
  });

  useEffect(() => {
    setErrors({})
  }, [langSwitch])

  useEffect(() => {
    createCaptcha();
  }, []);

  const handleInputChange = (e) => {
    const { name, type, value, files } = e.target;

    if (name === "image") {
      if (files?.length) {
        if (files[0].type !== "application/pdf") {
          setErrors((prevErrors) => ({ ...prevErrors, image: t("only PDF files are allowed") }));
          return;
        }
        setData((prevData) => ({
          ...prevData,
          [name]: files[0],
        }));
      } else {
        setData((prevData) => ({
          ...prevData,
          [name]: prevData?.image,
        }));
      }
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value.trim(),
      }));
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };


  const validateForm = () => {
    const newErrors = {};
    const regex = /^[A-Za-z\u0600-\u06FF\s]+$/;

    // First Name
    if (!data?.name?.trim()) {
      newErrors.name = t("first name is required");
    } else if (!regex.test(data.name)) {
      newErrors.name = t("invalid name format, allow only alphabets");
    }

    // Last Name (optional? If required, add a not-empty check)
    if (data?.last_name?.trim() && !regex.test(data.last_name)) {
      newErrors.last_name = t("invalid name format, allow only alphabets");
    }

    // Email
    if (!data?.email?.trim()) {
      newErrors.email = t("Email is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = t("Invalid email address");
    }

    // Subject
    if (!data?.subject?.trim()) {
      newErrors.subject = t("subject is required");
    }

    // Phone (optional, but if provided, must match format)
    if (data?.phone?.trim()) {
      if (!/^\+?\d{5,14}$/.test(data.phone)) {
        newErrors.phone = t("invalid phone number format");
      }
    }

    // Message
    if (!data?.message?.trim()) {
      newErrors.message = t("Message is required");
    }

    // File upload (PDF only)
    const allowedFormats = /\.pdf$/i;
    if (data?.image && !allowedFormats.test(data.image.name)) {
      newErrors.image = t("Invalid file format. Only PDF is supported");
    }

    // Captcha
    if (!value || value.trim() === "") {
      newErrors.captcha = t("captcha is required");
    } else if (value !== captchaValue) {
      newErrors.captcha = t("Invalid captcha");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  function createCaptcha() {
    let code;
    document.getElementById("captcha").innerHTML = "";
    let charsArray =
      "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@!#$%^&*";
    let lengthOtp = 6;
    let captcha = [];
    for (let i = 0; i < lengthOtp; i++) {
      //below code will not allow Repetition of Characters
      var index = Math.floor(Math.random() * charsArray?.length + 1); //get the next character from the array
      if (captcha.indexOf(charsArray[index]) == -1)
        captcha.push(charsArray[index]);
      else i--;
    }
    let canv = document.createElement("canvas");
    canv.id = "captcha";
    canv.width = 130;
    canv.height = 50;
    let ctx = canv.getContext("2d");
    ctx.font = "25px Georgia";
    ctx.strokeText(captcha.join(""), 0, 30);

    code = captcha.join("");
    document.getElementById("captcha").appendChild(canv);
    setCaptchaValue(code);
  }




  const handleSubmit = (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      setDisabled(true);
      let formData = new FormData();
      formData.append('name', data?.name);
      data?.last_name && formData.append('last_name', data?.last_name);
      formData.append('email', data?.email);
      data?.phone && formData.append('phone', data?.phone);
      formData.append('message', data?.message);
      formData.append('subject', data?.subject);
      data?.image && formData.append('image', data?.image);
      data?.phone && formData.append('country_code', data?.country_code);

      dispatch(contactEnquiry(formData, (res) => {
        if (res) {
          toast.success(t(res.data.message), {
            position: "bottom-center",
            autoClose: 3000
          })
          createCaptcha();
          setValue("");
          setDisabled(false);
          setData({
            name: '',
            email: '',
            phone: '',
            message: '',
            image: '',
            country_code: "+971"
          });
          e.target.reset();
        }
      }))
    }
  };

  let countryCode = getCountries().map((code) => ({
    value: `+${getCountryCallingCode(code)}`,
    label: `+${getCountryCallingCode(code)}`,
  })).sort((a, b) => {
    if (a.value === '+971') return -1;
    if (b.value === '+971') return 1;
    return parseInt(a.value.slice(1)) - parseInt(b.value.slice(1));
  });

  countryCode = countryCode.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.value === value.value
    ))
  )

  const handleCountryCode = (selectedOption) => {
    setErrors((prev) => ({
      ...prev,
      country_code: "",
    }));

    setData((prev) => ({
      ...prev,
      country_code: selectedOption?.value || "",
    }));
  };


  return (
    <>

      <section className="contact_us">
        <Container>
          <TitleBar
            title={t('contact us')}
            breadcrumbs={[
              { name: `${t('home')}`, path: "/" },
              { name: `${t('contact us')}`, path: "/contact" },
            ]}
            noBtn
          />

          <div className="contact__details">
            <div className="row align-items-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-4 col-tab-12 address_grid" data-aos="fade-up" data-aos-duration="1000">
                    <div className="icon">
                      <img src="/assets/img/icons/c-location.svg" alt="" />
                    </div>
                    <div className="content">
                      <h4>{langSwitch ? contactData?.address_title : contactData?.address_title_ar}</h4>
                      <p>{langSwitch ? contactData?.address : contactData?.address_ar}</p>
                    </div>
                  </div>
                  <div className="col-md-4 col-tab-6 address_grid" data-aos="fade-up" data-aos-duration="1500">
                    <div className="icon">
                      <img src="/assets/img/icons/c-mail.svg" alt="" />
                    </div>
                    <div className="content">
                      <h4>{t('email')}</h4>
                      <p><a href={`mailto:${contactData?.email}`}>{contactData?.email}</a></p>
                    </div>
                  </div>
                  <div className="col-md-4 col-tab-6 address_grid" data-aos="fade-up" data-aos-duration="2000">
                    <div className="icon">
                      <img src="/assets/img/icons/c-phone.svg" alt="" />
                    </div>
                    <div className="content">
                      <h4>{t('phone')}</h4>
                      <p dir="ltr"><a href={`tel:${contactData?.mobile}`}>{contactData?.telephone}</a></p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 text-right" data-aos="fade-up" data-aos-duration="1500">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <div className="forms contact__form">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <input type="text" name="name" ref={ref} className="form-control" placeholder={`${t('first name')} *`} onChange={handleInputChange} autoComplete="off" />
                          <p className="error">{errors?.name}</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <input type="text" name="last_name" ref={ref} className="form-control" placeholder={t('last name')} onChange={handleInputChange} autoComplete="off" />
                          <p className="error">{errors?.last_name}</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <input type="text" name="email" ref={ref} className="form-control email__contactus" placeholder={`${t('email')} *`} onChange={handleInputChange} autoComplete="off" />
                          <p className="error">{errors?.email}</p>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="d-flex gap-2" style={{ height: "100%" }}>
                            <Select
                              options={countryCode}
                              value={countryCode.find(option => option.value === data?.country_code) || ""}
                              className="country_code country_code_contact_page"
                              onChange={handleCountryCode}
                              placeholder={`${t("code")}*`}
                              styles={{
                                container: (provided) => ({
                                  ...provided,
                                  height: '100%',
                                  borderRadius: 7,
                                }),
                                menu: (base) => ({
                                  ...base,
                                  borderRadius: '7px',
                                  overflow: 'hidden'
                                }),
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: "48px",
                                  color: "white !important",
                                  border: "0.5px solid #516677",
                                  boxShadow: "none !important",
                                  borderRadius: "7px",
                                  overflow: "hidden",
                                  '&:hover': {
                                    borderColor: '#F28A3A',
                                    boxShadow: "none !important"
                                  },
                                  '&:active': {
                                    borderColor: '#F28A3A',
                                    boxShadow: "none !important"
                                  },
                                  backgroundColor: "#05253d"

                                }),
                                valueContainer: (provided) => ({
                                  ...provided,
                                  height: "48px",
                                  padding: "0px 6px",
                                  backgroundColor: "#05253d",
                                  color: "black",

                                }),
                                indicatorsContainer: (provided) => ({
                                  ...provided,
                                  height: "48px",
                                  backgroundColor: "#05253d",
                                  color: "black"
                                }),
                                singleValue: (provided, state) => ({
                                  ...provided,
                                  color: 'white',
                                  fontSize: "1rem"
                                }),
                                input: (base) => ({
                                  ...base,
                                  color: 'white',
                                  fontSize: "1rem"
                                }),
                              }}
                            />
                            <input type="number" name="phone" ref={ref} className="form-control" placeholder={t('phone number')} onChange={handleInputChange} autoComplete="off" />
                          </div>
                          <div className="d-flex gap-3">
                            {errors?.country_code && <p className="error">{errors.country_code}</p>}
                            {errors?.phone && <p className="error">{errors.phone}</p>}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <input maxLength={50} type="text" name="subject" ref={ref} className="form-control" placeholder={`${t('subject')} *`} onChange={handleInputChange} autoComplete="off" />
                          <p className="error">{errors?.subject}</p>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group ">
                          <textarea maxLength={500} name="message" ref={ref} placeholder={`${t('message')} *`} rows="4" className="form-control" onChange={handleInputChange} autoComplete="off"  ></textarea>
                          <p className="error">{errors?.message}</p>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <div className="form-group upload_attachment" onClick={() => fileInputRef.current.click()}>
                            <input
                              name="image"
                              onChange={handleInputChange}
                              multiple={false}
                              ref={fileInputRef}
                              type="file"
                              accept=".pdf"
                              hidden
                            />
                            <div>
                              <img width={30} src={'./assets/img/upload-cloud.svg'} alt="" />
                              <label
                                className="mx-3 attachement_text"
                                onClick={() => {
                                  const fileUrl = data?.image && URL.createObjectURL(data?.image);
                                  data?.image && window.open(fileUrl, '_blank');
                                }}
                              >
                                {data?.image ? data?.image?.name : t('Upload Attachment')}

                              </label>
                            </div>
                            <p className="supporting_document_text">{t('Supporting Document')} PDF</p>

                          </div>
                          <p className="error">{errors?.image}</p>
                        </div>
                      </div>
                      <div className="col-md-6 col-tab-12">
                        <div className="form-group mb-2">

                          <div className={"captcha_alignnment" + (i18n?.language === "en" ? ' lang-en' : ' lang-ar')}>
                            <div id="captcha" className="contact_captcha" ></div>
                            <input
                              type="text"
                              placeholder={`${t("enter captcha")} *`}
                              id="cpatchaTextBox"
                              className="form-control"
                              value={value}
                              dir="ltr"
                              onChange={(e) => {
                                setValue(e.target.value);
                                setErrors((prev) => ({
                                  ...prev,
                                  captcha: ""
                                }));
                              }}

                              autoComplete="off"
                            />
                            <div className="text-right captcha_refresh">
                              <div className="refresh_captcha" onClick={() => (createCaptcha(), setValue(""))}><img src="assets/img/icons/refresh.svg" /></div>
                            </div>
                          </div>
                          {errors?.captcha && (

                            <p className="error">{errors?.captcha}</p>
                          )}
                        </div>
                      </div>
                      <div className="col-md-12">

                        <button className="btn btn-outline-primary text-uppercase mt-3" disabled={loading}>
                          {t('submit now')}
                          {!loading ? "" :
                            <Spinner className="mx-2" animation="border" width={20} size="sm" />}
                        </button>
                      </div>
                    </div>



                    {/* <div className="form-group">
                    <select value={data?.country_code} onChange={handleInputChange} type="number" name="country_code" ref={ref} className="form-control custom-select" placeholder={t('country code')} autoComplete="off">
                      {countryCode?.map(item => <option value={item?.label}>{item?.label}</option>)}
                    </select>
                    <p className="error">{errors?.country_code}</p>
                  </div> */}



                    {/* <div className="form-group">
                    <input type="number" name="phone" ref={ref} className="form-control" placeholder={t('phone number')} onChange={handleInputChange} autoComplete="off" />
                    <p className="error">{errors?.phone}</p>
                  </div> */}





                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="map__container">
            <div className="row">
              <div
                id="map-container-google-2"
                className="z-depth-1-half map-container"
              >
                <iframe
                  src={`${contactData?.google_map_link}`}
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Contact;
